import { InfoCircleOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import { WarningIcon } from "@phosphor-icons/react";
import classNames from "classnames";
import { ReactNode } from "react";
export type StatusType = "loading" | "warning" | "error" | "info";
interface StatusDisplayProps {
  status?: StatusType;
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  width?: number;
}
export const StatusDisplay = ({
  status,
  icon: customIcon,
  title,
  description,
  actions,
  className,
  width
}: StatusDisplayProps) => {
  const getStatusIcon = () => {
    switch (status) {
      case "loading":
        return <Loading3QuartersOutlined spin />;
      case "warning":
        return <WarningIcon size={24} />;
      case "error":
        return <WarningIcon size={24} weight="fill" />;
      case "info":
        return <InfoCircleOutlined />;
      default:
        return null;
    }
  };
  const icon = customIcon || getStatusIcon();
  const isError = status === "error";
  return <div className={classNames("flex h-full min-h-0 w-full items-center justify-center gap-2", className)} data-sentry-component="StatusDisplay" data-sentry-source-file="StatusDisplay.tsx">
      <div className={classNames("flex max-w-lg items-start gap-4")} style={{
      width: width ? `${width}px` : "100%"
    }}>
        {icon && <div className={classNames("flex h-7 items-center justify-center text-2xl", isError ? "text-red-500" : "text-gray-400")}>
            {icon}
          </div>}
        <div className="min-w-0 flex-1">
          {title && <div className={classNames("text-xl font-medium leading-7", isError && "text-red-500")}>{title}</div>}
          {description && <div className="text-base text-gray-400">{description}</div>}
          {actions && <div className="mt-4">{actions}</div>}
        </div>
      </div>
    </div>;
};